import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateImagePage } from "../../dish-create/dish-create-image/dish-create-image";
import { DishServices } from "../../services";

@Component({
    selector: 'page-dish-view-photo',
    templateUrl: 'dish-view-photo.html',
})
export class DishViewPhotoPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public dishServices: DishServices,
        public globals: Globals,) { }

    edit() {
        if (this.globals.checkLimitsByLicense('dishes', 'image')) {
            this.navCtrl.push(DishCreateImagePage, {
                update: true,
                dish_uid: this.dish.UID,
                image: this.dish.image,
                image_url: this.dish.image_url,
                dish_name: this.globals.nameLangSelectDish(this.dish),
                dish: this.dish
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-photo/dish-view-photo.ts